export default __webpack_public_path__ + "static/david-6162ecf07a707942b110c9ef2220fb38.png";